import {Link} from 'react-router-dom';
import {ReactNode,useState,useEffect, SetStateAction} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';
import authBgSvg from './auth-bg.svg';
import {useTrans} from '@common/i18n/use-trans';
import {useSettings} from '@common/core/settings/use-settings';
import {Select} from '../../../ui/forms/select/select';
import {MenuItemConfig} from '@common/core/settings/settings';
import {useChangeLocale} from '@common/i18n/change-locale';
import {useValueLists} from '../../../http/value-lists';
import {Item} from '@common/ui/forms/listbox/item';
import {Trans} from '@common/i18n/trans';
interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
  updateLang: (lang: 'en' | 'tr') => void;
}
export function AuthLayout({heading, children, message,updateLang}: AuthPageProps) {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const {trans} = useTrans();
  const {data} = useValueLists(['localizations']);
  localStorage.setItem('lang','tr');
  const localizations = data?.localizations || [];
  console.log('localizations',localizations);
  const [val, setVal] = useState('en');
  const changeLocale = useChangeLocale();
  console.log('localizations',changeLocale);
  useEffect(()=>{
    let language = (changeLocale.data && changeLocale.data?.locale)?changeLocale.data?.locale.language:'en';
    setVal(language);
   
  },[])

  return (
    <>
    <header className=" w-full">
    <div
        className='w-1/2 flex items-center'
      >
    
    </div>
    </header>

       <section className="">
        <div className="flex w-full  text-slate-800">
   
           <div className="relative hidden h-screen select-none flex-col justify-center text-center md:flex md:w-1/2">
            <img className=" w-full max-w-full object-cover" src="./images/sidebn.png" />
          </div>
          <div className="flex flex-col w-full md:w-1/2 px-4">
                    <div className="flex items-center justify-between ">
                       {(val==='tr')?
                        <Link to="/">
                            <img src="./images/arrow-tr.png" className="h-[16px] mr-2 lg:h-[16px] " alt={val} />
                            </Link>:
                            <Link to="/">
                            <img src="./images/arrow.png" className="h-[16px] mr-2 lg:h-[16px] " alt="Logo" />
                            </Link>
}
<div>
                            <img src="./images/logo.svg" className="h-[62px] mr-3 lg:h-[92px] flex justify-end " alt="Logo" /><span style={{color: '#0071bc', fontSize: '20px',paddingLeft:'24px',fontWeight:'600'}}>V 4.02</span>
                            </div>
                    </div>
                    <div className="flex flex-col w-full md:w-1/3 px-4" style={{paddingLeft:'18px'}}>
                    
                    <Select
      
     
      className="mb-20"
      selectionMode="single"
      selectedValue={val}
      onSelectionChange={(value) => {
       // onValueChange(value as string);
        console.log(value);
        if (typeof value === 'string') {
          setVal(value);
          updateLang(value as 'en' | 'tr');
          changeLocale.mutate({locale: value});
        } 
        
      }}
    >
      
      {localizations.map(localization => (
        <Item key={localization.language} value={localization.language}>
         {localization.name}
        </Item>
      ))}
    </Select></div>
        {children}
      </div>
    
      </div>
      </section>
      </>
  );
}
